"use strict";

var _interopRequireDefault = require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.releaseMonth = releaseMonth;
var _bossRequest = _interopRequireDefault(require("@/utils/bossRequest"));
function releaseMonth() {
  return (0, _bossRequest.default)({
    url: '/sysProject/yeaMonthList',
    method: 'get'
  });
}